import React, { useState } from 'react';
import styled from '@emotion/styled'
import { getDeltaYear, calulateBrandIncrement, getPlanType } from '../helper'
import PropTypes from 'prop-types';

const Field = styled.div`
    display:flex;
    margin-bottom:1rem;
    align-items:center;
`;

const Label = styled.label`
    flex: 0 0 100px;
`;

const Select = styled.select`
    display:block;
    width:100%;
    padding:1rem;
    border:1 px solid #e1e1e1;
    -webkit-appearance:none;/** lo que hace es quitarle la apariencia natural del select*/
`;

const InputRadio = styled.input`
    margin: 0 1rem;
`;

const Button = styled.button`
    background-color :#00838F;
    font-size:16px;
    width:100%;
    padding:1rem;
    color:#fff;
    text-transform:uppercase;
    font-weight:bold;
    border:none;
    transition :background-color .3s ease;
    margin-top:2rem;

    &:hover{
        cursor: pointer;
        background-color:#26C6DA;
    }
`;

const Error = styled.div`
    background-color:red;
    color:white;
    padding:1rem;
    width:100%;
    text-align:center;
    margin-bottom:2rem;
`;


const Form = ({ saveResume, isLoading }) => {

    const [error, hasError] = useState(false);

    const [data, saveData] = useState({
        brand: '',
        year: '',
        plan: 'basico',
    });

    //extraer los datos del state
    const { brand, year, plan } = data;

    //leer los datos del formulario
    const getInformation = e => {
        saveData({
            ...data,
            [e.target.name]: e.target.value
        })
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        if (brand.trim() === ''
            || year.trim() === ''
            || plan.trim() === '') {
            hasError(true);
            return;
        }
        hasError(false);

        // vase de 2000
        let result = 2000;

        // obtener la diferencia de años
        const difference = getDeltaYear(year);
        // por cada año hay que restar el de la base 3%
        // console.log(difference);
        result -= ((difference * 3) * result) / 100;

        //americano 15%
        //asiatico 5%
        // europeo 3%
        result = calulateBrandIncrement(brand) * result;
        // basico aumenta 20% 
        // completo 20% 
        const incrementPlan = getPlanType(plan) * result;
        // console.log(incrementPlan);
        result = parseFloat(incrementPlan).toFixed(2);
        // console.log(result);
        // Total
        isLoading(true);
        setTimeout(() => {

            // elimina el spinner
            isLoading(false);

            //pasa la info al componente principal
            saveResume({
                quotation: Number(result),
                data
            });
        }, 2000);

    }


    return (
        <form
            onSubmit={handleSubmit}
        >

            {error ? <Error> Todos los campos son obligatorios</Error> : null}

            <Field>
                <Label>Marca</Label>
                <Select
                    name="brand"
                    value={brand}
                    onChange={getInformation}
                >
                    <option value="">---Seleccione---</option>
                    <option value="americano">Americano</option>
                    <option value="europeo">Europeo</option>
                    <option value="asiatico">Asiático</option>
                </Select>

            </Field>
            <Field>
                <Label>Año</Label>
                <Select
                    name="year"
                    value={year}
                    onChange={getInformation}
                >
                    <option value="">-- Seleccione --</option>
                    <option value="2021">2021</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                    <option value="2018">2018</option>
                    <option value="2017">2017</option>
                    <option value="2016">2016</option>
                    <option value="2015">2015</option>
                    <option value="2014">2014</option>
                    <option value="2013">2013</option>
                    <option value="2012">2012</option>
                </Select>
            </Field>

            <Field>
                <Label>Plan</Label>
                <InputRadio
                    type="radio"
                    name="plan"
                    value="basic"
                    checked={plan === "basic"}
                    onChange={getInformation}
                />Básico
                <InputRadio
                    type="radio"
                    name="plan"
                    value="complete"
                    checked={plan === "complete"}
                    onChange={getInformation}
                />Completo
            </Field>
            <Button
                type="submit"
            >Cotizar</Button>
        </form>
    );
}

Form.propTypes = {
    saveResume: PropTypes.func.isRequired,
    isLoading: PropTypes.func.isRequired
}

export default Form;
